export const left_nav_bar_def = [
    {
        name:"rsi.rv.url",
        marginLeft: "margin-left: 5px;",
        title:"RV",
        icon: 'visibility',
        disabled:true,
        url:""
    },
    {   name:"rsi.ri.url",
        title:"RI",
        marginLeft: "margin-left: 6px;",
        icon: 'share',
        disabled: true,
        url: ""
    },
    {
        name: "rsi.mdm.url.router",
        title: "Admin",
        marginLeft: "margin-left: -3px;",
        icon: 'person',
        disabled: true,
        url: ""
    },
    {
        name: "rsi.dem.url",
        title: "DEM",
        marginLeft: "margin-left: 1px;",
        icon: 'dns',
        disabled: true,
        url: ""
    },
    {
        name: "rsi.tableau.url",
        title: "Tableau",
        marginLeft: "margin-left: -6px;",
        icon: 'timeline',
        disabled: true,
        url: ""
    },
    {
        name: "rsi.pbi.url",
        title: "Power BI",
        marginLeft: "margin-left: -9px;",
        icon: 'insert_chart_outlined',
        disabled: true,
        url: ""
    },
    {
        name: "rsi.irisrsa.url",
        title: "OSA",
        marginLeft: "margin-left: 1px;",
        icon: 'brightness_5',
        disabled: true,
        url: ""
    },
    {
        name: "rsi.pma.url",
        title: "Promo",
        marginLeft: "margin-left: -3px;",
        icon: 'spa',
        disabled: true,
        url: ""
    },
    {
        name:"rsi.isp.url",
        title:"ISP",
        icon:"phone_iphone",
        disabled: true,
        marginLeft: "margin-left: 3px;",
        url:""
    },
    {
        name:"rsi.rppm.url",
        title:"RPPM",
        icon:"mdi-account-key",
        disabled: true,
        marginLeft: "margin-left: -3px;",
        url:""
    }
];